// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "map" + "." + "5fbb06d48a9d94dae486" + ".min.css";
};